import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import closeImg from '@panel/commons/assets/icons/close.svg';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: ${select('white')};
  height: 240px;
  width: 400px;
  padding: 16px 22px 22px 16px;
  border-radius: 8px;
`;

const CloseCointainer = styled.div`
  width: 100%;
`;

const Close = styled.span`
  float: right;
  background-image: ${`url(${closeImg})`};
  background-repeat: no-repeat;
  background-position: center;
  height: 12px;
  width: 12px;
  cursor: pointer;
`;

const Title = styled.div`
  width: 100%;
  text-align: center;
  font-family: 'Hind';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0em;
`;

const Body = styled.div`
  width: 341px;
  height: 78px;
  font-family: 'Hind';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  white-space: initial;
  color: ${select('darkGray')};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledButton = styled.button`
  height: 48px;
  width: 176px;
  border-radius: 12px;
  font-family: 'Hind';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  border: 1px solid;
  border-color: ${getColor('primary')};
  color: ${props => (props.primary ? select('white') : select('black'))};
  background-color: ${props => (props.primary ? getColor('primary') : select('white'))};
  cursor: pointer;
`;

function ErrorFreeProduct({ closeModal, postingId }) {
  const { push } = useHistory();
  const { t } = useTranslation();
  return (
    <Container data-repa='step4-errorModal-container'>
      <CloseCointainer data-repa='step4-errorModal-containerClose'>
        <Close data-repa='step4-errorModal-containerClose-button' onClick={closeModal} />
      </CloseCointainer>
      <Title data-repa='step4-errorModal-title'>{t('publisher.step4.module1.modalErrorFree.title')}</Title>
      <Body data-repa='step4-errorModal-body'>{t('publisher.step4.module1.modalErrorFree.title.text')}</Body>
      <ButtonContainer data-repa='step4-errorModal-buttonContainer'>
        <StyledButton data-repa='step4-errorModal-buttonContainer-cta1' onClick={closeModal}>
          {t('publisher.step4.module1.modalErrorFree.button.cta')}
        </StyledButton>
        <StyledButton
          data-repa='step4-errorModal-buttonContainer-cta2'
          primary
          onClick={() => {
            const next = {
              pathname: '/avisos',
              search: `&codigo=${postingId}`
            };
            push(next);
          }}
        >
          {t('publisher.step4.module1.modalErrorFree.button.cta2')}
        </StyledButton>
      </ButtonContainer>
    </Container>
  );
}

export { ErrorFreeProduct };
